module.exports = __webpack_public_path__ + "img/bonus3.21f96a96.png";